import React from 'react';
import PageBanner from '../../components/PageBanner';
import { productionRouteBanners, productionRouteBannerAlts } from '../../constants/sectionBanners';
import './KidsZone.css';

const KidsZone = () => {
  return (
    <div className="kids-zone-page">
      <PageBanner
        title="Kids Zone"
        image={productionRouteBanners['kids-zone']}
        imageAlt={productionRouteBannerAlts['kids-zone']}
      />
      
      <section className="section">
        <div className="section-container">
          <div className="section-header">
            <h2 className="section-title">Kids Setup</h2>
            <div className="title-underline"></div>
            <p className="section-subtitle">
              Fun and safe kids zone setups for your events
            </p>
          </div>
          
          <div className="about-content">
            <p>
              Create a dedicated space for children at your event with our kids zone services. 
              We provide safe, engaging, and entertaining setups that keep children happy 
              while parents enjoy the main event.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default KidsZone;
